/**
 * A compact open-Staffing-Concern count (RP-34), beside a plan or Solution name in a list.
 *
 * Deliberately not a column: it shows only when there is something open, so a calm list
 * stays calm. Red while a Blocking Concern waits on the account team.
 */

import { MessageSquareWarning } from "lucide-react";
import { cn } from "@/lib/utils";
import type { PlanConcernSummary } from "@/schemas/plan-concerns";

export function ConcernCountBadge({ summary }: { summary: PlanConcernSummary | undefined }) {
  if (summary === undefined || summary.unresolved === 0) return null;
  const blocking = summary.blockingOpen > 0;
  const label = `${summary.unresolved} open Staffing Concern${summary.unresolved === 1 ? "" : "s"}${
    blocking ? ", blocking" : ""
  }`;
  return (
    <span
      className={cn(
        "ml-1.5 inline-flex items-center gap-0.5 rounded px-1.5 py-0.5 align-middle text-xs font-semibold tabular-nums",
        blocking
          ? "bg-error-100 text-error-700 dark:text-error-400"
          : "bg-warning-100 text-warning-700 dark:text-warning-400",
      )}
      title={label}
    >
      <MessageSquareWarning className="h-3 w-3" aria-hidden />
      <span aria-hidden>{summary.unresolved}</span>
      <span className="sr-only">{label}</span>
    </span>
  );
}
